<template>
  <div class="new-newsletter-modal" v-if="newsletterModalOpenCookie">
    <vch-modal
      :open="newsletterModalOpen"
      @closed="closeModals"
      :newsletter-popup="newsletterModalOpenCookie"
      :modal-heading-aria-label="modalHeadingAriaLabel"
    >
      <newsletter-popup-form
        :email-value="emailValue"
        :newsletter-popup-data-modal="newsletterPopupData"
        :data-modal-image-aria-label="dataModalImageAriaLabel"
        :pico-image-aria-label="picoImageAriaLabel"
        :email-aria-label="emailAriaLabel"
        :phone-aria-label="phoneAriaLabel"
        :subscribe-newsletter-aria-label="subscribeNewsletterAriaLabel"
        :subscribe-sms-marketing-aria-label="subscribeSmsMarketingAriaLabel"
        :submit-button-aria-label="submitButtonAriaLabel"
      />
    </vch-modal>
  </div>
</template>

<script>
import NewsletterPopupForm from './newsletter-popup.vue';

export default {
  name: 'newsletter-popup-modal',
  components: {
    NewsletterPopupForm,
  },
  props: {
    newsletterPopupData: {
      type: Object,
      required: true,
    },
    modalHeadingAriaLabel:{
      type: String,
      required: false,
      default: 'Modal heading',
    },
    dataModalImageAriaLabel:{
      type: String,
      required: false,
      default: 'Newsletter Modal Image',
    },
    picoImageAriaLabel:{
      type: String,
      required: false,
      default: 'Picto Image',
    },
    emailAriaLabel:{
      type: String,
      required: false,
      default: 'Email',
    },
    phoneAriaLabel:{
      type: String,
      required: false,
      default: 'Phone',
    },
    subscribeNewsletterAriaLabel:{
      type: String,
      required: false,
      default: 'Subscribe to Newsletter',
    },
    subscribeSmsMarketingAriaLabel:{
      type: String,
      required: false,
      default: 'Subscribe to SMS Marketing',
    },
    submitButtonAriaLabel:{
      type: String,
      required: false,
      default: 'Submit',
    },
  },
  data() {
    return {
      newsletterModalOpen: false,
      newsletterModalOpenCookie: false,
      currentVariantId: null,
      emailValue: '',
    };
  },
  mounted() {
    const vm = this;

    document
      .querySelector('.newsletter-popupform')
      .addEventListener('click', function (event) {
        event.preventDefault();
        const emailInput = document.querySelector(
          '[data-sc-field-name="email_address"]'
        );
        if (emailInput.value != '') {
          vm.emailValue = emailInput.value;
          vm.newsletterModalOpenCookie = true;
          document.querySelector('.field-validation-valid').textContent = '';
        } else {
          document.querySelector('.field-validation-valid').textContent =
            vm.newsletterPopupData.FieldEmail.IdError;
        }
      });
    this.checkCookie();
  },
  methods: {
    closeModals() {
      this.newsletterModalOpenCookie = false;
    },
    getCookie(cname) {
      let name = cname + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    },
    checkCookie() {
      let cookieCount = this.getCookie('NEWSLETTERPOPUP');
      if (cookieCount === this.newsletterPopupData.NumberOfPageNavigations) {
        this.newsletterModalOpenCookie = true;
      } else {
        this.newsletterModalOpenCookie = false;
      }
    },
  },
};
</script>

<style lang="scss" src="./newsletter-popup-modal.scss"></style>
